import React from "react";
import "../Styles/services.css";

const Services = () => {
  return (
    <div id="services" className="feature-section">
      <div className="flex-container">
        <h2 className="h1-copy">All Social Media Marketing Services</h2>
        <div className="w-layout-grid grid-all-services">
          {/* Twitter NFT Services */}
          <div className="feature-grid-block">
            <img
              src="https://cdn.prod.website-files.com/628d4467de238a5806753c9b/628f7f41e1fc940f34c472c0_twitter-icon.png"
              alt="Twitter icon"
              className="icon-image"
            />
            <div className="feature-header">Twitter NFT Services</div>

            <a href="/followertwitter" className="service-link">
              Twitter NFT Followers
            </a>
            <a href="/liketwitter" className="service-link">
              Twitter NFT Likes
            </a>
            <a href="/Viewstwitter" className="service-link">
              Twitter NFT Views
            </a>
            <a href="Commentstwitter" className="service-link">
              Twitter NFT Comments
            </a>
          </div>

          {/* Discord Services */}
          {/* <div className="feature-grid-block">
            <img
              src="https://cdn.prod.website-files.com/628d4467de238a5806753c9b/62a75d8247013b607d994982_discord-icon.png"
              alt="Discord services icon"
              className="icon-image"
            />
            <div className="feature-header">Discord Services</div>
            <a href="/services/buy-discord-members" className="service-link">
              Discord Members
            </a>
            <div className="feature-header">Discord NFT Services</div>
            <a
              href="/services/buy-discord-nft-members"
              className="service-link"
            >
              Discord NFT Members
            </a>
            <a
              href="/services/buy-discord-nft-reactions"
              className="service-link"
            >
              Discord NFT Reactions
            </a>
          </div> */}

          {/* Twitter Services */}
          {/* <div className="feature-grid-block">
            <img
              src="https://cdn.prod.website-files.com/628d4467de238a5806753c9b/6334701a469c3d1af98a2292_twitter-services-icon.svg"
              alt="Twitter Services Icon"
              className="icon-image"
            />
            <div className="feature-header">Twitter Services</div>
            <a href="/services/buy-twitter-followers" className="service-link">
              Twitter Followers
            </a>
            <a href="/followertwitter" className="service-link">
              Twitter USA Followers
            </a>
            <a href="/liketwitter" className="service-link">
              Twitter Likes
            </a>
            <a href="/services/buy-twitter-retweets" className="service-link">
              Twitter Retweets
            </a>
            <a href="/Viewstwitter" className="service-link">
              Twitter Views
            </a>
            <a href="/Commentstwitter" className="service-link">
              Twitter Comments
            </a>
          </div> */}

          {/* Instagram Services */}
          <div className="feature-grid-block">
            <img
              src="https://cdn.prod.website-files.com/628d4467de238a5806753c9b/628f7f41df3229565fda1eb2_ig-icon.png"
              alt="Instagram Icon"
              className="icon-image"
            />
            <div className="feature-header">Instagram</div>
            {/* <a href="/followerinstagram" className="service-link">
              Instagram Followers
            </a>
            <a href="/likesinsta" className="service-link">
              Instagram Likes
            </a>

            <a href="/Viewsinsta" className="service-link">
              Instagram Views
            </a>
            <a
              href="/services/buy-custom-instagram-comments"
              className="service-link"
            >
              Instagram Custom / Random Comments
            </a> */}
            <a href="/followerinstagram" className="service-link">
              Instagram Reel Views
            </a>
            <a href="/likesinsta" className="service-link">
              Instagram Reel Likes
            </a>
            <a href="/Viewsinsta" className="service-link">
              Instagram Live Views
            </a>
            <a href="/Commentsinsta" className="service-link">
              Instagram Comments
            </a>
          </div>

          {/* TikTok Services */}
          <div className="feature-grid-block">
            <img
              src="https://cdn.prod.website-files.com/628d4467de238a5806753c9b/628f7ff87f6b6e6ba8895d4b_tiktok-icon.png"
              alt="TikTok Icon"
              className="icon-image"
            />
            <div className="feature-header">TikTok</div>
            <a href="/liketiktok" className="service-link">
              TikTok Likes
            </a>
            <a href="/viewtiktok" className="service-link">
              TikTok Views
            </a>
            <a href="/Commentstiktok" className="service-link">
              TikTok Comments
            </a>
            <a href="/followertiktok" className="service-link">
              Tiktok Followers
            </a>
          </div>

          {/* Twitch Services */}
          <div className="feature-grid-block">
            <img
              src="https://cdn.prod.website-files.com/628d4467de238a5806753c9b/666c51fe86bce6f112e2f5e2_twitch-logo.svg"
              alt="Twitch logo"
              className="icon-image"
            />
            <div className="feature-header">Twitch</div>
            <a href="/viewtwitch" className="service-link">
              Twitch Viewers
            </a>
            <a href="/followertwitch" className="service-link">
              Twitch Followers
            </a>
          </div>

          {/* Reddit Services */}

          {/* Spotify Services */}
          {/* <div className="feature-grid-block">
            <img
              src="https://cdn.prod.website-files.com/628d4467de238a5806753c9b/643c6281e4f9df2eace7f50b_spotify-logo-socialplug.webp"
              alt="Spotify Services"
              className="icon-image"
            />
            <div className="feature-header">Spotify</div>
            <a href="/services/buy-spotify-plays" className="service-link">
              Spotify Plays
            </a>
            <a
              href="/services/buy-spotify-monthly-listeners"
              className="service-link"
            >
              Spotify Monthly Listeners
            </a>
            <a href="/services/buy-spotify-followers" className="service-link">
              Spotify Followers
            </a>
            <a
              href="/services/buy-spotify-playlist-followers"
              className="service-link"
            >
              Spotify Playlist Followers
            </a>
          </div> */}

          {/* LinkedIn Services */}
          {/* <div className="feature-grid-block">
            <img
              src="https://cdn.prod.website-files.com/628d4467de238a5806753c9b/6474d2dde02948e47151cb3c_Linkedin-icon.svg"
              alt="LinkedIn Services"
              className="icon-image"
            />
            <div className="feature-header">LinkedIn</div>
            <a
              href="/services/buy-linkedin-connections"
              className="service-link"
            >
              LinkedIn Connections
            </a>
            <a href="/services/buy-linkedin-followers" className="service-link">
              LinkedIn Followers
            </a>
            <a href="/services/buy-linkedin-likes" className="service-link">
              LinkedIn Likes
            </a>
            <a href="/services/buy-linkedin-comments" className="service-link">
              LinkedIn Comments
            </a>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default Services;
